// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ICategoryServiceDto } from './ICategoryServiceDto';
import {
    ICategoryServiceDtoFromJSON,
    ICategoryServiceDtoFromJSONTyped,
    ICategoryServiceDtoToJSON,
    ICategoryServiceDtoToJSONTyped,
} from './ICategoryServiceDto';

/**
 * 
 * @export
 * @interface IPolicyEligibleServicesDto
 */
export interface IPolicyEligibleServicesDto {
    /**
     * 
     * @type {number}
     * @memberof IPolicyEligibleServicesDto
     */
    policy_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IPolicyEligibleServicesDto
     */
    total?: number;
    /**
     * 
     * @type {Array<ICategoryServiceDto>}
     * @memberof IPolicyEligibleServicesDto
     */
    categories?: Array<ICategoryServiceDto>;
}

/**
 * Check if a given object implements the IPolicyEligibleServicesDto interface.
 */
export function instanceOfIPolicyEligibleServicesDto(value: object): value is IPolicyEligibleServicesDto {
    return true;
}

export function IPolicyEligibleServicesDtoFromJSON(json: any): IPolicyEligibleServicesDto {
    return IPolicyEligibleServicesDtoFromJSONTyped(json, false);
}

export function IPolicyEligibleServicesDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPolicyEligibleServicesDto {
    if (json == null) {
        return json;
    }
    return {
        
        'policy_id': json['policy_id'] == null ? undefined : json['policy_id'],
        'total': json['total'] == null ? undefined : json['total'],
        'categories': json['categories'] == null ? undefined : ((json['categories'] as Array<any>).map(ICategoryServiceDtoFromJSON)),
    };
}

export function IPolicyEligibleServicesDtoToJSON(json: any): IPolicyEligibleServicesDto {
    return IPolicyEligibleServicesDtoToJSONTyped(json, false);
}

export function IPolicyEligibleServicesDtoToJSONTyped(value?: IPolicyEligibleServicesDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'policy_id': value['policy_id'],
        'total': value['total'],
        'categories': value['categories'] == null ? undefined : ((value['categories'] as Array<any>).map(ICategoryServiceDtoToJSON)),
    };
}

